<template>
  <div class="items-center flex gap-2">
    <div class="loader" />
    <p :class="{ 'loader-text': isPulsing }">
      {{ loadingMessage }}
    </p>
  </div>
</template>
<script setup lang="ts">
import { generateMessageWithDelay } from '@app/utils/generateTextWithDelay'
import { onMounted, ref } from 'vue'

const { message } = defineProps<{
  message: string
}>()
const loadingMessage = ref('')
const isPulsing = ref(true)
async function typeText(): Promise<void> {
  const generator = generateMessageWithDelay(message, 200)
  for await (const word of generator) {
    loadingMessage.value += `${word} `
  }
  isPulsing.value = false
}
onMounted(() => {
  typeText()
})
</script>

<style scoped>
.loader {
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation:
    scale 1.5s linear infinite,
    change-color 9s linear infinite;
}

@keyframes scale {
  0% {
    border-width: 4px;
  }
  50% {
    border-width: 16px;
  }
  100% {
    border-width: 4px;
  }
}

@keyframes change-color {
  0% {
    border-color: #3498db;
  }
  25% {
    border-color: #e74c3c;
  }
  50% {
    border-color: #f1c40f;
  }
  75% {
    border-color: #2ecc71;
  }
  100% {
    border-color: #3498db;
  }
}

.loader-text {
  animation: pulse 400ms infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.4;
  }
}
</style>
